













import { Suggestion } from '@empathy/search-types';
import { Components } from '@empathybroker/ebx-gluon';
import { Component } from 'vue-property-decorator';

@Component
export default class GoccoTermSuggestion extends Components.Pure.TermSuggestion {
  suggestion: Suggestion;

  get hasFirstFilter() {
    return this.suggestion.facets[0] && this.suggestion.facets[0].filters[0];
  }
}
